import AspApi from '../../../api/ApiConfig';

const BASE = '/api/v1/svc/campaign_sequence/sequences';

/**
 * Fetch all sequences for a brand (standalone)
 */
export const fetchSequencesList = async (brandId, options = {}) => {
  const {
    page = 1,
    limit = 20,
    search = '',
    status = '',
    sortBy = 'created_at',
    sortOrder = 'desc'
  } = options;

  const params = new URLSearchParams({
    brand_id: brandId,
    page,
    limit,
    ...(search && { search }),
    ...(status && { status }),
    sort_by: sortBy,
    sort_order: sortOrder
  });

  const res = await AspApi.get(`${BASE}?${params.toString()}`);
  return res;
};

/**
 * Create a new standalone sequence
 */
export const createStandaloneSequence = async (data) => {
  const res = await AspApi.post(`${BASE}/create_standalone`, {
    name: data.name,
    brand_id: data.brand_id,
    start_date: data.start_date,
    end_date: data.end_date
  });
  return res;
};

/**
 * Get sequence details by ID (standalone)
 */
export const getSequenceDetails = async (sequenceId) => {
  const res = await AspApi.get(`${BASE}/${sequenceId}/show_standalone`);
  return res;
};

/**
 * Update sequence (standalone)
 */
export const updateSequence = async (sequenceId, data) => {
  const res = await AspApi.put(`${BASE}/${sequenceId}/update_standalone`, {
    sequence: data
  });
  return res;
};

/**
 * Delete sequence (standalone)
 */
export const deleteSequence = async (sequenceId) => {
  const res = await AspApi.delete(`${BASE}/${sequenceId}/delete_standalone`);
  return res;
};

/**
 * Change sequence status (uses legacy route — requires campaign_id)
 */
export const changeSequenceStatus = async (brandId, sequenceId, campaignId, action) => {
  const res = await AspApi.put(
    `${BASE}/${sequenceId}/change_state`,
    { brand_id: brandId, campaign_id: campaignId, state_action: action }
  );
  return res;
};
